module.exports = __webpack_public_path__ + "img/coffee.0cf6a2dc.svg";